import { render } from "./CreateResourceButton.vue?vue&type=template&id=7e41d698"
import script from "./CreateResourceButton.vue?vue&type=script&lang=js"
export * from "./CreateResourceButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateResourceButton.vue"]])

export default __exports__